<sb-message-wrapper [messageType]="'received'" [photoUrl]="photoUrl">
  <div class="content t-7@r color-jet">
    Typing

    <i class="line-center i-4@r">
      <svg
        xml:space="preserve"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        class="icon"
        version="1.1"
        viewBox="0 0 24 24"
        x="0px"
        xmlns="http://www.w3.org/2000/svg"
        y="0px"
      >
        <circle class="icon__indicator icon__indicator--1" cx="3" cy="16" fill="#444444" r="1.5" />
        <circle class="icon__indicator icon__indicator--2" cx="12" cy="16" fill="#444444" r="1.5" />
        <circle class="icon__indicator icon__indicator--3" cx="21" cy="16" fill="#444444" r="1.5" />
      </svg>
    </i>
  </div>
</sb-message-wrapper>
